import api from './index';
// axios
import request from '@/utils/request';

// 验证用户是否存在
export function userCheck(params) {
  return request({
    url: api.userCheck,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 用户注册
export function userRegister(params) {
  return request({
    url: api.userRegister,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 用户信息
export function userInfo(params) {
  return request({
    url: api.userInfo,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 主题列表
export function threadList(params) {
  return request({
    url: api.threadList,
    method: 'get',
    params: params,
    hideloading: true
  });
}

// 话题列表
export function topicList(params) {
  return request({
    url: api.topicList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 详情
export function detail(params) {
  return request({
    url: api.detail,
    method: 'get',
    params: params,
    hideloading: true
  });
}

// 评论列表
export function comments(params) {
  return request({
    url: api.comments,
    method: 'get',
    params: params,
    hideloading: true
  });
}

// 关注
export function follow(params) {
  return request({
    url: api.follow,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 取消关注
export function unFollow(params) {
  return request({
    url: api.unFollow,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 单个话题列表
export function signalTopicList(params) {
  return request({
    url: api.signalTopicList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 发布评论
export function postComments(params) {
  return request({
    url: api.postComments,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 点赞评论
export function thumbs(params) {
  return request({
    url: api.thumbs,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 单个评论列表
export function signalComment(params) {
  return request({
    url: api.signalComment,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// banner列表
export function banner(params) {
  return request({
    url: api.banner,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 版块列表
export function categories(params) {
  return request({
    url: api.categories,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 版块绑定
export function categoriesBind(params) {
  return request({
    url: api.categoriesBind,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 我的绑定版块
export function myCategories(params) {
  return request({
    url: api.myCategories,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 创建话题
export function topicCreate(params) {
  return request({
    url: api.topicCreate,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 活动列表
export function activityList(params) {
  return request({
    url: api.activityList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 活动列表
export function activityDetail(params) {
  return request({
    url: api.activityDetail,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 推荐关键词列表
export function recommendKeywords(params) {
  return request({
    url: api.recommendKeywords,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 上传图片
export function uploadImg(params) {
  return request({
    url: api.uploadImg,
    method: 'post',
    contentType: 'multipart/form-data',
    data: params,
    hideloading: true
  });
}

// 发帖
export function post(params) {
  return request({
    url: api.post,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 收藏
export function collect(params) {
  return request({
    url: api.collect,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 报名
export function signUp(params) {
  return request({
    url: api.signUp,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 问卷列表
export function paperList(params) {
  return request({
    url: api.paperList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 问卷详情
export function paperDetail(params) {
  return request({
    url: api.paperDetail,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 问题列表
export function questionList(params) {
  return request({
    url: api.questionList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 答题
export function answerQuestion(params) {
  return request({
    url: api.answerQuestion,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 消息
export function message(params) {
  return request({
    url: api.message,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 消息列表
export function noticeList(params) {
  return request({
    url: api.noticeList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 关注列表
export function followList(params) {
  return request({
    url: api.followList,
    method: 'get',
    params: params,
    hideloading: false
  });
}

// 修改个人资料
export function userInfoModify(params) {
  return request({
    url: api.userInfoModify,
    method: 'post',
    data: params,
    hideloading: false
  });
}

// 删除自己帖子
export function threadDelete(params) {
  return request({
    url: api.threadDelete,
    method: 'post',
    data: params,
    hideloading: false
  });
}
// 分享增加积分
export function shareIntegral(params) {
  return request({
    url: api.share,
    method: 'post',
    data: params,
    hideloading: false
  });
}
// 分享增加积分
export function updateInfo(params) {
  return request({
    url: api.updateInfo,
    method: 'post',
    data: params,
    hideloading: false
  });
}
// 获取活动报名人数
export function getJoinNum(params) {
  return request({
    url: api.getJoinNum,
    method: 'get',
    params: params,
    hideloading: true
  });
}